import { MinimalAppContext } from 'generated-common';

export interface CodeclouUrlParameter {
  name: string;
  value: any;
  type: 'query' | 'path';
}

export const urlEncodeAndCleanParameterOrValue = (paramKeyOrValue: string): string | null => {
  let encodedValue = '';
  if (!paramKeyOrValue || typeof paramKeyOrValue !== 'string') {
    return null;
  }
  // STRIP NOT ALLOWED CHARS
  encodedValue = paramKeyOrValue.replace(/[^-+_a-zA-Z0-9]*/g, ''); // + and - is allowed because of sorting in URL e.g. sort=+field1
  // ENCODE
  return encodeURIComponent(encodedValue);
};

// Nullsafe URL Encoding of param pairs in style "param=value"
export const urlEncodeAndCleanParameterAndValueAsURLParam = (param: string, value: string, prependAmpersand: boolean): string => {
  const paramEncoded = urlEncodeAndCleanParameterOrValue(param);
  const valueEncoded = urlEncodeAndCleanParameterOrValue(value);
  if (paramEncoded && valueEncoded) {
    return `${prependAmpersand ? '&' : ''}${paramEncoded}=${valueEncoded}`;
  }
  return '';
};

/*
 * Safely encodes the URL and all URL Parameters escaped and safe to use.
 * Nullsafe!
 * When baseUrl is set it will be prepended!
 * NOTE: When in Frontend use it from ReactGlobalContext and the BaseUrl will be injected automatically
 */
export const encodeUriSafe = (baseUrl: string | null, uri: string, params: CodeclouUrlParameter[] | null): string => {
  let finalUrl = '';
  if (baseUrl) {
    finalUrl = baseUrl;
  }
  finalUrl = `${finalUrl}${uri}`;
  // PARAMS
  if (params) {
    let doPrependAmpersand = false;
    for (let param of params) {
      // CASE 1: Path Params with /foo/:pathParam1
      if (param.type === 'path') {
        finalUrl = finalUrl.replace(`/:${urlEncodeAndCleanParameterOrValue(param.name)}`, `/${urlEncodeAndCleanParameterOrValue(param.value)}`);
      }
      // CASE 2: Query Params as /foo?queryParam1=foo
      if (param.type === 'query') {
        finalUrl = `${finalUrl}${doPrependAmpersand ? '' : '?'}${urlEncodeAndCleanParameterAndValueAsURLParam(param.name, param.value, doPrependAmpersand)}`;
        doPrependAmpersand = true;
      }
    }
  }
  return finalUrl;
};

export const buildBaseUrlByAppIdAndEnvIdAndModuleType = (minimalContext: MinimalAppContext): string => {
  if (!minimalContext) {
    return '';
  }
  //
  // CASE 1: Jira Project Page:
  //
  // /jira/software/projects/DEMO/apps/b726b105-b97f-4309-902b-c47864c4dc51/efeabbde-e061-434b-bfc0-6e1ab2488096
  // /jira/core/projects/COR/apps/b726b105-b97f-4309-902b-c47864c4dc51/efeabbde-e061-434b-bfc0-6e1ab2488096
  // a.s.o
  //
  if (minimalContext.extensionType === 'jira:projectPage') {
    return `/jira/${minimalContext.projectType ? minimalContext.projectType : 'UNKNOWN'}/${minimalContext.projectKey ? minimalContext.projectKey : 'UNKNOWN'}/apps/${minimalContext.appId}/${
      minimalContext.envId
    }`;
  }

  //
  // CASE 2: Jira Admin Page
  // /jira/settings/apps/b726b105-b97f-4309-902b-c47864c4dc51/efeabbde-e061-434b-bfc0-6e1ab2488096
  //
  if (minimalContext.extensionType === 'jira:adminPage') {
    return `/jira/settings/apps/${minimalContext.appId}/${minimalContext.envId}`;
  }
  // ELSE
  return '';
};
